import { addMethod, string } from 'yup'

export const noSpecialCharacters = () => {
  addMethod(string, 'excludeSpecialCharacters', function () {
    return this.test('test-special-characters', function (value, type) {
      const specialCharactersMessage = 'Special characters not allowed.'

      // Uses context from ValidationSchema
      if (value && type.path === 'email') {
        const { path, createError } = this
        return (
          // Require '@' since regex is post Yup email regex and will error without
          // Yup email regex sets up guidelines for email
          // noSpecialCharacters is a whitelist for special chars
          !new RegExp(/[^\w._%+\-@]/).test(value) ||
          createError({ path, message: specialCharactersMessage })
        )
      } else if (value) {
        const { path, createError } = this
        return (
          // Require \s since other forms have spaces in input
          // Validation schemas with noSpecialCharacters use it post Yup regex
          !new RegExp(/[^\w._+\-\s]/).test(value) ||
          createError({ path, message: specialCharactersMessage })
        )
      }
      return true
    })
  })
}
